
import { API_URLS } from "../helpers/api/API_URLS";
import { basicGET } from "../helpers/api/fetchParams";

export async function getAudit(service, id) {
    var token = localStorage.getItem("token");
    const response = await fetch(API_URLS.API+"audit/"+service+"/"+id, basicGET(token));
    if (!response.ok) {
        const message = 'An error has occured: '+response.status;
        throw new Error(message);
    }
    const data = await response.json();
    return data;
}


// WEBPACK FOOTER //
// ./src/data/serviceChangeLogs.js